import React, { useEffect, useState, useRef } from 'react';
import {
  Button, Radio,
  FormController,
  FormLabel, RadioGroup, SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { NO } from '../constants/constants';

const keyToLabel = {
  neverSignedUp: 'I don’t remember signing up for emails',
  tooMany: 'I receive too many emails',
  cantView: 'I can’t view the emails',
  arntRelevant: 'The emails aren’t relevant to me'
};

const checkBoxKeys = Object.keys(keyToLabel);

export const OptOutReasonFeedback = ({
  selectedOptOuts,
  setSelectedOptOuts,
  callApi
}) => {

  const [selectedOption, setSelectedOption] = useState('');
  const optOutRef = useRef();
  const clickedOutsideTheComponent = (event) => {
    if (optOutRef?.current && !optOutRef?.current?.contains(event.target)) {
      setSelectedOptOuts([]);
      setSelectedOption('');
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', clickedOutsideTheComponent);
    return () => {
      document.removeEventListener('mousedown', () => {});
    };
  }, []);
  const handleChange = (event, value) => {
    setSelectedOption(keyToLabel[value]);
  };

  const submitDisabled = !selectedOption;

  const submitOptOutReason = () => {
    const subscriptions = selectedOptOuts.map((opt) => {
      return {
        type: opt,
        status: NO,
        optOutReasonFeedback: selectedOption
      };
    });

    callApi(subscriptions);
    setSelectedOption('');
  };

  return selectedOptOuts.length !== 0 && (
    <div ref={optOutRef}>
      <FormController
        fullWidth
        component="fieldset"
      >
        <FormLabel>To help us improve your experience, please tell us why you unsubscribed.</FormLabel>
        <RadioGroup onChange={handleChange}>
          {checkBoxKeys.map((key) => (
            <SelectionControlLabel value={key} key={key} label={keyToLabel[key]}>
              <Radio />
            </SelectionControlLabel>
          ))}
        </RadioGroup>
      </FormController>
      <div className="sui-grid sui-grid-cols-8">
        <div className="sui-col-span-5" />
        <div className="sui-col-span-3">
          <Button disabled={submitDisabled} fullWidth onClick={submitOptOutReason}>
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

OptOutReasonFeedback.propTypes = {
  callApi: PropTypes.func.isRequired,
  setSelectedOptOuts: PropTypes.func.isRequired,
  selectedOptOuts: PropTypes.arrayOf(PropTypes.string).isRequired
};
